module.exports = __webpack_public_path__ + "02_short_gold.993600cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/02_short_gold.png
// module id = 20bS
// module chunks = 0